import React from 'react';
import { useSelector } from 'react-redux';
import Layout from '../../components/layout';
import { NotFoundPage } from '../404';
import { issuerSelector, authSelector } from '../../selectors';
import VerificationPopup from '../../components/abc/popup/verification-popup/VerificationPopup';
import ExpressionOfInterestPopup from '../../components/abc/popup/expression-of-interest-popup/expression-of-interest-popups';
import { useGetIssuerShortname } from '../../hooks/use-get-issuer-shortname';
import { Homepage } from '../../components/abc/homepage/homepage';

export const Homescreen = () => {
  const companyShortName = useGetIssuerShortname();

  const { employerOnboard } = useSelector(issuerSelector);
  const { error } = useSelector(authSelector);

  if (error === 'notFound') {
    return <NotFoundPage />;
  }

  if (companyShortName && companyShortName !== '' && !employerOnboard) {
    return <NotFoundPage />;
  }

  return (
    <Layout>
      <VerificationPopup />
      <ExpressionOfInterestPopup />
      <Homepage />
    </Layout>
  );
};
